import * as React from "react";
import { Modal, Spin, Tabs } from "antd";
import { EditForm } from "./EditForm";
import ListUserCourseData from "./ListUserCourseData";
import { getAllUser } from "../../Graphs/User/listUser";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  FolderOutlined,
  GlobalOutlined,
  TeamOutlined
} from "@ant-design/icons";

const { TabPane } = Tabs;

const InfoChip = ({ label, value, icon, gradient }) => {
  return (
    <div style={{
      background: "#fff",
      border: "1px solid #eef2f6",
      borderRadius: "12px",
      padding: "16px",
      display: "flex",
      alignItems: "center",
      gap: "16px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
      transition: "all 0.2s ease",
    }}>
      <div style={{
        background: gradient || "linear-gradient(135deg, #e0c3fc 0%, #8ec5fc 100%)",
        borderRadius: "50%",
        width: "42px",
        height: "42px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontSize: "18px",
        flexShrink: 0
      }}>
        {icon}
      </div>
      <div>
        <div style={{ color: "#8c8c8c", fontSize: "11px", textTransform: "uppercase", fontWeight: "600", letterSpacing: "0.5px" }}>{label}</div>
        <div style={{ color: "#262626", fontSize: "14px", fontWeight: "600", marginTop: "4px", wordBreak: "break-all" }}>
          {value || "-"}
        </div>
      </div>
    </div>
  );
};

export class ListModel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      data: [],
      recordDetails: {},
      isLoading: false, // Fixme this should be true
      closable: true,
      tabKey: "inprogess",
    };
  }

  componentDidMount() {
    if (this.props.refx) {
      this.props.refx(this);
    }

    const uId = this.props.match?.params?.userId;

    // ✅ Extract data from props, history state or localStorage backup
    let adminSelectedData = this.props.adminSelectedData;
    if (!adminSelectedData) {
      if (
        this.props &&
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.adminSelectedData
      ) {
        adminSelectedData = this.props.location.state.adminSelectedData;
      } else {
        try {
          adminSelectedData = JSON.parse(localStorage.getItem("view_user_details"));
        } catch (e) {
          console.error("Error parsing user details from localStorage", e);
        }
      }
    }

    // Ensure the loaded user ID matches the URL param if present
    if (uId && adminSelectedData && adminSelectedData._id !== uId) {
      adminSelectedData = null;
    }

    if (adminSelectedData) {
      this.setState({ recordDetails: adminSelectedData }, () =>
        this.fetchUserData(adminSelectedData)
      );
    } else {
      this.fetchUserData(null);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.adminSelectedData !== prevProps.adminSelectedData && this.props.adminSelectedData) {
      this.setState({ recordDetails: this.props.adminSelectedData }, () =>
        this.fetchUserData(this.props.adminSelectedData)
      );
    }
  }

  fetchUserData = async (data) => {
    this.setState({ isLoading: true });
    try {
      const result = await getAllUser(this.props.authToken, 0, 100);
      console.log("API Result:", result);
      if (result.status === 200) {
        this.setState({
          data: result.data,
          isLoading: false,
        });

        const uId = this.props.match?.params?.userId;
        if (uId && (!this.state.recordDetails || this.state.recordDetails._id !== uId)) {
          const foundUser = result.data.find(u => u._id === uId);
          if (foundUser) {
            this.setState({ recordDetails: foundUser });
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ isLoading: false });
    }
  };

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.hide();
  };

  // show() {
  //     this.setState({
  //         visible: true
  //     });
  // }

  // hide() {
  //     this.setState({
  //         visible: false
  //     });
  //     this.props.onClose();
  // }

  render() {
    const { recordDetails } = this.state;
    return (
      <div style={{ padding: "20px" }}>
        {recordDetails && (
          <div style={{ 
            background: "#fff", 
            padding: "24px", 
            borderRadius: "8px", 
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)", 
            marginBottom: "24px",
            border: "1px solid #f0f0f0"
          }}>
            <h2 style={{ margin: "0 0 16px 0", color: "#1f1f1f", fontSize: "20px" }}>User Details</h2>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "16px" }}>
              <InfoChip 
                label="Name" 
                value={`${recordDetails.first_name || ""} ${recordDetails.last_name || ""}`} 
                icon={<UserOutlined />} 
                gradient="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
              />
              <InfoChip 
                label="Email" 
                value={recordDetails.email} 
                icon={<MailOutlined />} 
                gradient="linear-gradient(135deg, #00b4db 0%, #0083b0 100%)"
              />
              <InfoChip 
                label="Phone" 
                value={recordDetails.phone} 
                icon={<PhoneOutlined />} 
                gradient="linear-gradient(135deg, #ff9966 0%, #ff5e62 100%)"
              />
              <InfoChip 
                label="Category" 
                value={recordDetails.category} 
                icon={<FolderOutlined />} 
                gradient="linear-gradient(135deg, #11998e 0%, #38ef7d 100%)"
              />
              <InfoChip 
                label="Site" 
                value={recordDetails.site} 
                icon={<GlobalOutlined />} 
                gradient="linear-gradient(135deg, #f857a6 0%, #ff5858 100%)"
              />
              {recordDetails.group_details && (
                <InfoChip 
                  label="Group" 
                  value={recordDetails.group_details.first_name ? `${recordDetails.group_details.first_name} ${recordDetails.group_details.last_name || ''}`.trim() : (recordDetails.group_details.username || recordDetails.group_details.email)} 
                  icon={<TeamOutlined />} 
                  gradient="linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)"
                />
              )}
            </div>
          </div>
        )}

        <h2>List User Courses</h2>
        {/* <ListUserCourseData adminSelectedData={this.props?.adminSelectedData} /> */}
        <Tabs
          defaultActiveKey="session"
          onChange={(key) => {
            console.log({ key });
            //   setTabKey(key)
            this.setState({
              tabKey: key,
            });
          }}
          type="card"
        >
          {/* <TabPane tab="In Progress" key="inprogess">
                            {this.state.tabKey === 'inprogess' && (
                                <ListUserCourseData adminSelectedData={this.props.adminSelectedData} type={this.state.tabKey} key={this.state.tabKey}/>
                            )}
                        </TabPane>
                        <TabPane tab="Completed" key="completed">
                            {this.state.tabKey === 'completed' && (
                                <ListUserCourseData adminSelectedData={this.props.adminSelectedData} type={this.state.tabKey} key={this.state.tabKey}/>
                            )}
                        </TabPane> */}

          <TabPane tab="In Progress" key="inprogess">
            {this.state.tabKey === "inprogess" && (
              <ListUserCourseData
                adminSelectedData={this.state.recordDetails}
                type={this.state.tabKey}
                data={this.state.data}
                key={this.state.tabKey}
              />
            )}
          </TabPane>
          <TabPane tab="Completed" key="completed">
            {this.state.tabKey === "completed" && (
              <ListUserCourseData
                adminSelectedData={this.state.recordDetails}
                type={this.state.tabKey}
                data={this.state.data}
                key={this.state.tabKey}
              />
            )}
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
});

export default connect(mapStateToProps)(withRouter(ListModel));
